import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FinanceiroService } from '../../../../services/financeiro.service';
import { ContasAPagar, ContasAPagarDTO, BaixarContaRequest, ResumoContasAVencer } from '../../../../models/financeiro.model';
import { Parametros } from '../../../../models/parametros.model';
import { ParametrosService } from '../../../../services/parametros.service';
import { ErrorModel } from '../../../../models/error.model';
import { AuthService } from '../../../../services/auth.service';
import { ConfirmDialogComponent } from '../../../modal/confirm-dialog/confirm-dialog';
import { todayLocalDateString, nowLocalISOString } from '../../../../core/utils/date.util';


@Component({
  selector: 'app-contas-a-pagar',
  standalone: true,
  imports: [CommonModule, FormsModule, ConfirmDialogComponent],
  templateUrl: './contas-a-pagar.component.html',
  styleUrls: ['./contas-a-pagar.component.css']
})
export class ContasAPagarComponent implements OnInit {
  contas: ContasAPagarDTO[] = [];
  conta: ContasAPagar = this.getEmptyConta();
  parametroSelecionado: Parametros = this.getParametrosEmpty();
  currentPage = 0;
  itemsPerPage = 10;
  totalPages = 1;
  totalElements = 0;
  filteredContas: ContasAPagarDTO[] = [];
 
  
  searchTerm = '';

  // Card de contas a vencer: a contagem vem do servidor porque a listagem é paginada.
  readonly diasAVencer = 7;
  resumoAVencer: ResumoContasAVencer | null = null;
  isCarregandoResumo = true;
  hasErroResumo = false;

  parametros: Parametros[] = [];

  // Pagination
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  showPagarModal = false;
  isConfirmDialogOpen = false;
  contaIdParaExcluir: number | null = null;
  
  selectedContaId: number = 0;
  selectedValor: number = 0;
  selectedFormaRetirada: string = 'Pix';
  selectedDataPagamento: string = todayLocalDateString();
  selectedObservacao: string = '';



  constructor(
    private financeiroService: FinanceiroService, 
    private router: Router,
    private parametrosService: ParametrosService,
    private toastr: ToastrService,
    private auth: AuthService
  ) { }
  
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.handlePostSaveToast();
    this.loadContas();
    this.loadResumoAVencer();
    this.loadParametros();
  }

  loadResumoAVencer(): void {
    this.isCarregandoResumo = true;
    this.hasErroResumo = false;

    this.financeiroService.getResumoContasAVencer(this.diasAVencer).subscribe({
      next: (resumo) => {
        this.resumoAVencer = resumo;
        this.isCarregandoResumo = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.resumoAVencer = null;
        this.hasErroResumo = true;
        this.isCarregandoResumo = false;
        this.cdr.detectChanges();
      }
    });
  }

  private handlePostSaveToast(): void {
    const navigationState = this.router.getCurrentNavigation()?.extras.state;
    const successMessage = navigationState?.['successMessage'] || history.state?.successMessage;

    if (!successMessage) {
      return;
    }

    this.toastr.success(successMessage);
    const currentState = { ...history.state };
    delete currentState.successMessage;
    window.history.replaceState(currentState, '');
  }

  loadContas(): void {
    this.financeiroService.getContasAPagar(this.currentPage, this.itemsPerPage, this.searchTerm).subscribe(data => {
      this.contas = data.content;
      this.filteredContas = data.content;
      this.totalPages = data.totalPages;
      this.totalElements = data.totalElements;
      this.updatePageNumbers();
      this.cdr.detectChanges();
    });
  }

  search(): void {
        if (this.searchTerm.length) {
        this.financeiroService.getContasAPagarGenerico(this.currentPage, this.itemsPerPage, this.searchTerm).subscribe(data => {
          this.contas = data.content;
          this.filteredContas = data.content;
          this.totalPages = data.totalPages;
          this.totalElements = data.totalElements;
          this.updatePageNumbers();
          this.cdr.detectChanges();
        });
        }
  }


  applyFilter(): void {

  }

  setPage(page: number): void {
    if (page < 0 || page >= this.totalPages) {
      return;
    }
    this.currentPage = page;
    if (this.searchTerm.trim() === ''){
      this.loadContas();
    } else {
      this.search();
    }
  }

  updatePageNumbers(): void {
    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(0, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages - 1, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(0, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from({ length: (this.endPage - this.startPage) + 1 }, (_, i) => this.startPage + i);
  }

  novaConta(): void {
    // Implementar a navegação para a tela de manutenção
     this.router.navigate(['/home', 'financeiro-conta-a-pagar-manutencao']);
  }

  incluirLote(): void {
     this.router.navigate(['/home', 'financeiro-conta-a-pagar-lote']);
  }

  editarConta(id: number): void {
    // Implementar a navegação para a tela de manutenção
    this.router.navigate(['/home', 'financeiro-conta-a-pagar-manutencao', id]);
  }

  deleteConta(id: number): void {
    this.contaIdParaExcluir = id;
    this.isConfirmDialogOpen = true;
  }

  fecharDialogExcluirConta(): void {
    this.isConfirmDialogOpen = false;
    this.contaIdParaExcluir = null;
  }

  confirmarExclusaoConta(): void {
    const id = this.contaIdParaExcluir;

    if (id === null) {
      this.fecharDialogExcluirConta();
      return;
    }

    this.financeiroService.deleteContasAPagar(id).subscribe({
      next: () => {
        this.loadContas();
        this.loadResumoAVencer();
        this.toastr.success('Conta excluída com sucesso!');
        this.fecharDialogExcluirConta();
        },
      error: (error) => {
          this.toastr.error(error.error.message);
          this.fecharDialogExcluirConta();
      }
    });
  }

  pagarConta(id: number, valor: number): void { 
      this.selectedContaId = id;
      this.selectedValor = valor;
      this.selectedDataPagamento = todayLocalDateString();
      this.selectedObservacao = '';
      this.showPagarModal = true;
  }

  closePagarModal(): void {
    this.showPagarModal = false;
  }

  confirmarPagamento(): void {
    let user = this.auth.getUser();
    if (user === null){
      this.toastr.error("Efetuar login novamente");
      this.router.navigate(['/login']);
      return;
    }

    const payload: BaixarContaRequest = {
      idConta: this.selectedContaId,
      valorPago: this.selectedValor,
      formaRetirada: this.selectedFormaRetirada,
      dataPagamento: this.selectedDataPagamento,
      observacao: this.selectedObservacao,
      idUsuario: user.id
    };

    this.financeiroService.baixarConta(payload).subscribe({
          next: () => {
            this.loadContas();
            this.loadResumoAVencer();
            this.toastr.success('Pagamento confirmado com sucesso!');
             this.closePagarModal();
          },
          error: (error) => {
            var erro: ErrorModel = error.error;
            this.toastr.error(erro.message);
          }});
  }

  getEmptyConta(): ContasAPagar {
    return {
      id: 0,
      fornecedor: { id: 0, razaoSocial: '', nomeFantasia: '', cnpj: '', inscricaoEstadual: '', inscricaoMunicipal: '', endereco: '', cidade: '', estado: '', cep: '', numeroPredial: '', telefone: '', email: '', site: '', observacoes: '' },
      descricao: '',
      valor_a_pagar: 0,
      valor_final: 0,
      dataVencimento: '',
      dataPagamento: '',
      status: 'AGUARDANDO',
      destino: '',
      observacao: '',
      dataCadastro: nowLocalISOString(),
      grupo: { id: 0, nome: '', createdAt: '' },
      subgrupo: { id: 0, nome: '', createdAt: '', grupo: { id: 0, nome: '', createdAt: '' } },
      formaRetirada: ''
    };
  }

  loadParametros(): void {
    this.parametrosService.getParametrosByCategorias(['FORMA_PAGAMENTO']).subscribe(data => {
      this.parametros = data;
    });
  }


  getParametrosEmpty(): Parametros {
    return {
      id: 0,
      descricao: '',
      valorMaximo: '',
      valorMinimo: '',
      valorNumerico: '',
      categoria: ''
    };
  }

}
